<script>
import {Carousel, Slide} from "vue-carousel";
import Layout from "@/pages/home/layout";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {CONSTANTS} from "@/helpers/constants";

/**
 * Basic-table component
 */
export default {
  page: {
    title: "Lịch sử",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader,Multiselect },
  data() {
    return {

      data: [],
      pageOptions: [5, 10, 25, 50, 100],
      fields: [
        { key: 'STT',
          label: 'STT',
          class: 'cs-text-center',
          sortable: false,
          thClass: 'hidden-sortable',
        },
        {
          key: "createdAtShow",
          label: "Thời gian",
          class: 'cs-text-center tb-time',
          sortable: true,
        },
        {
          key: "content",
          label: "Nội dung câu hỏi",
          class: 'tb-ques',
          sortable: true,
          thStyle: "text-align:center",
        },
        {
          key: "answer",
          label: "Nội dung câu trả lời",
          class: 'tb-answer',
          sortable: true,
          thStyle: "text-align:center",
        }
      ],
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 10,
      sortBy: "age",
      filter: null,
      sortDesc: false,
      filterOn: [],
      listLinhVuc : [],
      listDonVi : [],
      listMucDo: [],
      itemFilter: {
        Content : null,
        Level : null,
        Administration :null,
        Domain:null,
        CitizenId : null
      },
      currentUserAuth: null,
    };
  },

  created() {
    window.addEventListener("scroll", this.windowScroll);
    let authUser = localStorage.getItem("auth-user");
    if (authUser) {
      let jsonUserCurrent = JSON.parse(authUser);
      this.currentUserAuth = jsonUserCurrent;
  //    console.log("CURRENT USER AUTH  created HOI DAP: ", this.currentUserAuth)
    }
    this.getAllLinhVuc("ALL");
    this.getAllDonVi();
    this.getAllMucDo();
  },

  methods: {
    myProvider (ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        level: this.itemFilter.Level ,
        administration: this.itemFilter.Administration,
        domain: this.itemFilter.Domain,
        content : this.itemFilter.Content,
        CitizenId:  this.currentUserAuth != null ? this.currentUserAuth.id : null
      }
      this.loading = true
      try {
        let promise =  this.$store.dispatch("messageStore/getPagingParams", params)
        return promise.then(resp => {
          if(resp.code === 0){
            let items = resp.data.data ;
            this.totalRows = resp.data.totalRows
            this.numberOfElement = resp.data.data.length
            this.loading = false
            return items || []
          }else{
            return [];
          }
        })
      } finally {
        this.loading = false
      }
    },

    async getAllLinhVuc(code) {
      await this.$store.dispatch("syncStore/getAllLinhVuc", code).then((res) => {
        this.listLinhVuc = res.data.data || [];
      })
    },

    async getAllDonVi() {
      await this.$store.dispatch("syncStore/getAllDonVi").then((res) => {
        this.valueLinhVuc = null;
        this.listDonVi = res.data.data || [];
      })
    },
    handleSearch() {
      console.log("LOG HANDLE SEARCH " , this.itemFilter)
      this.$refs.tblList.refresh();
    },
    handleClear(){
      this.itemFilter = {
        Content:  null,
        Level : null,
        Administration :null,
        Domain:null
      } ;
    },
    async getAllMucDo() {
      await this.$store.dispatch("syncStore/getAllMucDo").then((res) => {
        this.listMucDo = res.data || [];
      })
    },
  },

  watch: {
    'itemFilter.Administration': {
      handler(val){
        console.log("LOG ITEM :" , this.itemFilter)
        this.getAllLinhVuc(this.itemFilter.Administration.administrationCode);
      },
      deep: true
    }
  }

};


</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="card container" style="margin-top: 0px !important;">
          <div class="card-body">
            <h3 class="font-weight-bold me-2" style="color: #000;">
              LỊCH SỬ CÂU HỎI CỦA BẠN
            </h3>
            <div class="row">
              <div class="col-12" style="margin-bottom: 10px;">
                <input
                    v-model="itemFilter.Content"
                    type="text"
                    name="untyped-input"
                    class="form-control"
                    placeholder="Tìm kiếm theo tên mã thủ tục"
                    style="height: 50px; font-size: 16px; border: 1.5px solid #ccc;"
                />
              </div>
              <div class="col-4">
                <div class="mb-3">
                  <!-- <label class="text-left fs-4">Chọn cơ quan quản lý</label>
                  <span style="color: red">&nbsp;*</span> -->
                  <multiselect
                      v-model="itemFilter.Administration"
                      :options="listDonVi"
                      :multiple="false"
                      track-by="administrationCode"
                      class="helo"
                      selectLabel="Nhấn vào để chọn"
                      deselectLabel="Nhấn vào để xóa"
                      label="administrationName"
                      placeholder="Chọn cơ quan quản lý"
                  ></multiselect>
                </div>
              </div>
              <div class="col-4">
                <div class="mb-3">
                  <multiselect
                      v-model="itemFilter.Domain"
                      :options="listLinhVuc"
                      :multiple="false"
                      track-by="id"
                      class="helo"
                      selectLabel="Nhấn vào để chọn"
                      deselectLabel="Nhấn vào để xóa"
                      label="domainName"
                      placeholder="Chọn lĩnh vực"
                  ></multiselect>
                </div>
              </div>
              <div class="col-4">
                <div class="mb-3">
                  <multiselect
                      v-model="itemFilter.Level"
                      :options="listMucDo"
                      :multiple="false"
                      track-by="id"
                      class="helo"
                      selectLabel="Nhấn vào để chọn"
                      deselectLabel="Nhấn vào để xóa"
                      label="name"
                      placeholder="Chọn mức độ"
                  ></multiselect>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-center">
                <b-button variant=""
                          class="w-10 btn-search"
                          style="margin-right: 10px ; height: 40px ; width: 130px"
                          size="sm"
                          @click="handleSearch"
                >
                  <i
                      class="bx bx-search font-size-16 align-middle me-2"
                  ></i>
                  Tìm kiếm
                </b-button>
                <b-button
                    class="w-10 btn-reset"
                    style="margin-right: 10px; height: 40px ; width: 130px"
                    size="sm"
                    @click="handleClear"
                >
                  <i class="mdi mdi-replay font-size-16 align-middle me-2"></i>
                  Làm mới
                </b-button>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div
                    class="col-sm-12 d-flex justify-content-left align-items-center"
                >
                  <div
                      id="tickets-table_length"
                      class="dataTables_length m-1"
                      style="
                        display: flex;
                        justify-content: left;
                        align-items: center;
                      "
                  >
                    <div class="me-1">Hiển thị </div>
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                        style="width: 70px"
                    ></b-form-select
                    >&nbsp;
                    <div style="width: 100px"> dòng </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                  class=""
                  :items="myProvider"
                  :fields="fields"
                  striped
                  bordered
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  ref="tblList"
                  primary-key="id"
              >
                <template v-slot:cell(STT)="data">
                  {{ data.index + ((currentPage-1)*perPage) + 1  }}
                </template>
                <template v-slot:cell(serviceCode)="data">
                <span v-if="data.item.serviceCodeDVCQG !== ''">
                 {{ data.item.serviceCodeDVCQG}}
                </span>
                  <span v-else>
                  {{ data.item.serviceCode }}
                </span>
                </template>
                <template v-slot:cell(maxLevel)="data">
                <span v-if="data.item.maxLevel === 4" class="bg-danger" >
                  DVCTT Toàn trình
                </span>
                  <span v-else-if ="data.item.maxLevel === 3" class="bg-warning">
                  DVCTT Một phần
                </span>
                  <span v-else class="bg-success">
                  Còn lại
                </span>
                </template>
                <template v-slot:cell(process)="data">
                  <button
                      type="button"
                      size="sm"
                      class="btn btn-outline btn-sm"
                  >
                    <i class="fas fa-pencil-alt text-success me-1"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <b-col>
                <div>Hiển thị {{numberOfElement}} trên tổng số {{totalRows}} dòng</div>
              </b-col>
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          </div>
    </Layout>
</template>

<style>
.btn-search, .btn-reset{
  font-size: 16px;
  background-color: #204b03 !important;
}

.card{
    margin-top: 230px;
}

.card-title{
    font-size: 20px;
    color: #000;
}

.table th{
  background-color: rgb(9, 100, 9);
  color: #fff;
  border: 1px solid #ccc;
}

tbody tr td{
  text-align: justify;
}

.cs-text-center{
  text-align: center;
}

.tb-time{
  width: 10% !important;
}

.tb-ques{
  width: 40% !important;
}

.tb-answer{
  width: 50% !important;
}

.page-item.active .page-link {
    background-color: rgb(9, 100, 9) !important;
}

.multiselect__option--highlight, .multiselect__option--highlight:after{
  background-color: #204b03 !important;
}

</style>
